import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Panel, Ok, When } from "./Panel";

export const HeaderCheckPanel = ({ admin, last, onChange }) => {
  const [h, setH] = useState("");
  const check = async () => {
    try { await api.post("/email-marketing/launch/header-check", { headers: h }); setH(""); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not analyse headers"); }
  };
  return (
    <Panel testid="launch-headers" title="4. Microsoft delivery test (SPF / DKIM / DMARC alignment)" right={<When at={last?.at} />}
      sub="Send a campaign test to an Outlook/Hotmail address on your test list, then paste that message's full headers here (Outlook: File → Properties → Internet headers). Only domains and pass/fail results are stored.">
      {last && <div className="grid gap-1 sm:grid-cols-2" data-testid="header-result">
        <Ok ok={last.microsoft}>Received by Microsoft ({last.microsoft ? "yes" : "no"})</Ok>
        <Ok ok={last.spf === "pass"}>SPF {last.spf} · Return-Path {last.return_path_domain}</Ok>
        <Ok ok={last.dkim === "pass"}>DKIM {last.dkim} · d={last.dkim_verified_domain || last.dkim_signing_domains.join(",")}</Ok>
        <Ok ok={last.dmarc === "pass"}>DMARC {last.dmarc} · compauth {last.compauth} {last.compauth_reason || ""}</Ok>
        <Ok ok={last.spf_aligned}>SPF aligned with From ({last.from_domain})</Ok><Ok ok={last.dkim_aligned}>DKIM aligned with From</Ok>
        {last.problems.length > 0 && <p className="text-xs text-red-600 sm:col-span-2">{last.problems.join(" · ")}</p>}</div>}
      {admin && <><Textarea value={h} onChange={(e) => setH(e.target.value)} rows={4} placeholder="Paste full message headers" className="text-xs font-mono" data-testid="header-input" />
        <Button size="sm" disabled={h.length < 50} onClick={check} data-testid="header-check-btn">Analyse headers</Button></>}
    </Panel>
  );
};
